export default __webpack_public_path__ + "d150db71234abb45c9f7c67bc87ce14c.png";